import { render, staticRenderFns } from "./PDFCreate.vue?vue&type=template&id=f58fa256&"
import script from "./PDFCreate.vue?vue&type=script&lang=js&"
export * from "./PDFCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports